'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function TZFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-surdztohu", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-bo6xkuvpf", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-9b52g3xns" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-9b52g3xns", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-surdztohu)" }, /* @__PURE__ */ React.createElement("use", { fill: "#3195f9", xlinkHref: "#mantine-9b52g3xns" }), /* @__PURE__ */ React.createElement("path", { fill: "#73be4a", d: "M0 0v24L32 0z", mask: "url(#mantine-bo6xkuvpf)" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#272727",
        fillRule: "nonzero",
        stroke: "#ffd018",
        strokeWidth: "2.5",
        d: "M33.604-4.519L37.213.887-1.127 26.48l-3.61-5.406z",
        mask: "url(#mantine-bo6xkuvpf)"
      }
    )))
  );
}

export { TZFlag };
//# sourceMappingURL=TZ.mjs.map
